/* @flow */

// Librairies
import * as React from 'react';
import { useIntl } from 'react-intl';

// Styles
import styles from './GratitudeSponsors.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Hooks
import useEvent from 'src/shared/domain/event/hook/useEvent';

// Utils
import messages from 'src/shared/app/expression-of-gratitude/l10n/expressionOfGratitudel10n.json';
import { slugify } from 'src/shared/core/util/stringUtil';
import {
  getEventPlugins,
  getEventSponsorPluginLevelIsEnabled,
  getEventGratitudeModalSponsors,
} from '@braindate/domain/lib/event/util';
import {
  gratitudeModalLevel,
  sponsorshipPlugin as sponsorshipPluginKey,
} from 'src/shared/app/feature/settings/featureSettings';

// Components
import ResponsivePicture from '@braindate/ui/lib/component/ResponsivePicture';

// Types
import type { BraindateEventSponsor } from '@braindate/domain/lib/event/type';

const useStyles = createUseThemeStyles(styles);

const GratitudeSponsors = () => {
  const classes = useStyles();
  const event = useEvent();
  const intl = useIntl();

  const sponsorshipPlugin = getEventPlugins(event)[sponsorshipPluginKey];
  const isSponsorPluginEnabled =
    sponsorshipPlugin &&
    getEventSponsorPluginLevelIsEnabled(sponsorshipPlugin, gratitudeModalLevel);
  const sponsors: BraindateEventSponsor[] = isSponsorPluginEnabled
    ? getEventGratitudeModalSponsors(event)
    : [];

  if (!sponsors.length) return null;

  return (
    <>
      <p className={classes.sponsorsTitle}>
        {intl.formatMessage(messages.sponsoredBy)}
      </p>
      <div className={classes.sponsorsContainer}>
        {sponsors.map((sponsor, key) => {
          const { body, href, logo } = sponsor;
          const { name } = body[intl.locale];

          return (
            <a
              href={href}
              className={classes.sponsorLogo}
              target="_blank"
              rel="noreferrer"
              key={`gratitude-sponsor-${slugify(name || key.toString())}`}
            >
              <ResponsivePicture
                picture={logo}
                alt={name}
                provideFallback={true}
              />
            </a>
          );
        })}
      </div>
    </>
  );
};

export default React.memo<{}>(GratitudeSponsors);
